export const FONT = "'Hanken Grotesk', sans-serif";

export const CORTILE = {
  cream: '#FFFDF8',
  slate: '#1F2320',
  slateHover: '#383D39',
  terracotta: '#CE5B36',
  terracottaDark: '#B84D2C',
  muted: '#5F635E',
  placeholder: '#8D918B',
  border: '#D9D4CB',
  divider: '#ECE8DF',
  hoverFill: '#F5F1E8',
  disabled: '#B9B6AE',
  error: '#A3431F',
  focusRing: '0 0 0 3px rgba(206,91,54,0.18)',
};
